import OcrInterceptor from '../OcrInterceptor'

const api = new OcrInterceptor()

export default {
  getDebugFileResult(file: any) {
    return api.postFormData(`/ocr/debug`, file)
  },
}
